import { createSlice, PayloadAction } from '@reduxjs/toolkit';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface UserControlState {
  //
  initials: string;
  //
} // HomeState

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: UserControlState = {
  initials: '',
};

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const userControlSlice = createSlice({
  name: 'userControl',
  initialState: initialState,
  reducers: {
    //
    setInitials: (state: UserControlState, action: PayloadAction<string>) => {
      state.initials = action.payload;
    },
    //
  },
  //extraReducers: (builder) => {
  //  builder
  //    .addCase(initiateDMSearch.fulfilled, (state: FileBrowserState) => {})
  //},
});

// expose the interface.
export const { setInitials } = userControlSlice.actions;
export default userControlSlice.reducer;
